<template lang="pug">
.modal-backdrop(v-if="visible" @touchmove.prevent)
  .modal-container
    .modal-header
      span {{title}}
    .header-desc(v-if="showTask") 完成以下任务可领取奖励金
    .modal-body.flex-mid
      template(v-if="showTask")
        .task-container
          bounty-coupon-alipay(
            :new-module="newModule",
            :data="taskList2Show",
            :preparing="preparing",
            :frameTask='frameTask'
          )
          .tips
            span 温馨提示：
            span 1.在“做任务领奖励金”中可领取更多任务获取奖励金
            span 2.坚持每日签到，也可获得奖励金
              span.yellow (在APP中签到，奖励金翻倍)
      template(v-else)
        .desc 坚持每日签到，也可获得奖励金
          span.yellow (在APP中签到，奖励金翻倍)
    .modal-footer(v-if="!showTask" @click="cancel")
      .modal-btn 我知道了
    .modal-close(@click="cancel")
</template>

<script>
import Modal from '@/components/modal';
import { TASK_STATUS_V2 } from '@/const/task';
import { env } from '@hb/NBridge/lib/h5';
import {
  getTaskListV2, getBountyBasicInfo,
} from '@/api/bounty';
import { getTokenAndKey, getCityInfo } from '@/utils';
import { getVersion } from '@/utils/systemCode';
import { mapTaskV2 } from '@/utils/mappers';
import BountyCouponAlipay from '../components/bounty-coupon-alipay.vue';

export default {
  components: {
    Modal,
    BountyCouponAlipay,
  },
  data() {
    return {
      taskList: [],
      bounty: null,
      info: null,
      visible: false,
      newModule: true,
      preparing: true,
      frameTask: false,
    };
  },
  computed: {
    showTask() {
      return !!this.taskList.length;
    },
    title() {
      if (this.showTask && this.info) {
        const diff = this.info.cost - this.bounty;
        return `仅差${diff < 0 ? 0 : Number(diff).toFixed(2)}个奖励金`;
      }
      return '奖励金不足';
    },
    taskList2Show() {
      if (this.taskList.length > 3) {
        return this.taskList.slice(0, 3);
      }
      return this.taskList;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.preparing) {
        this.preparing = false;
      }
    }, 2000);

    // this.init();
  },
  methods: {
    async init() {
      const [
        { token }, cityInfo,
      ] = await Promise.all([getTokenAndKey(), getCityInfo()]);
      const [basic, task] = await Promise.all([
        getBountyBasicInfo({ token, pointType: 1 }).then((v) => v.data).catch(() => null),
        getTaskListV2({
          token,
          channelId: env.platformCode,
          sceneNameEn: 'platform_points',
          subSceneNameEn: 'platform_points_pointshp',
          taskStatusList: [TASK_STATUS_V2.INIT, TASK_STATUS_V2.RUNNING],
          queryUnrewardedTasks: true,
          version: await getVersion(),
          ...cityInfo,
        }).then((v) => v.data).catch(() => null),
      ]);
      if (task && task.taskList) {
        this.taskList = task.taskList.map(mapTaskV2);
      }

      if (basic) {
        this.bounty = basic.points || 0;
      }

      if (this.preparing) {
        this.preparing = false;
      }
    },
    open(info) {
      this.info = info;
      this.init();
      this.$nextTick(() => { this.visible = true; });
      this.frameTask = true;
    },
    cancel() {
      this.visible = false;
      this.frameTask = false;
    },
  },
};
</script>

<style lang="less" scoped>
.font(@fw , @co , @lh , @fs) {
  font-weight: @fw;
  color: @co;
  line-height: @lh;
  font-size: @fs;
}

.width(@w) {
  width: @w;
  max-width: @w;
  min-width: @w;
}

.modal-backdrop {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.49);
}

.modal-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.12rem;
  padding: 0.24rem 0.12rem 0.24rem 0.12rem;
  .width(3.2rem);

  .modal-header {
    text-align: center;
    .font(500, #242729, 0.25rem, 0.18rem);
  }

  .header-desc {
    margin: 0.04rem 0 0.2rem;
    text-align: center;
    .font(400, #5a6066, 0.2rem, 0.14rem);
  }

  .modal-body {
    .font(400, #999, 0.17rem, 0.12rem);

    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 0.02rem;
    }

    .desc {
      margin: 0.16rem 0.12rem 0.2rem;
      color: #5a6066;
      line-height: 0.2rem;
      font-size: 0.14rem;
      text-align: center;
    }

    .task-container {
      max-width: 100%;

      /deep/ .task-item {
        background: #f7f9fa;
        border-radius: 0.04rem;
        padding: 0.13rem 0.06rem;

        .title {
          max-width: 1.13rem !important;
        }

        &:not(:first-of-type) {
          margin-top: 0.08rem;
        }

        .right {
          .btn {
            width: 0.57rem !important;
          }
        }
      }
    }
  }

  .modal-footer {
    .modal-btn {
      background: #08f;
      border-radius: 0.08rem;
      padding: 0.12rem 1.08rem;
      .font(500, #fff, 0.25rem, 0.18rem);
    }
  }

  .yellow {
    color: #ff5526;
  }

  .modal-close {
    margin: 0;
    display: block;
    position: fixed;
    top: 0.14rem;
    right: 0.14rem;
    width: 0.2rem;
    height: 0.2rem;
    z-index: 2000;

    &::before,
    &::after {
      content: " ";
      display: block;
      position: absolute;
      top: 0.04rem;
      right: -0.02rem;
      width: 0.16rem;
      height: 2px;
      transform: translateY(-50%) rotate(45deg);
      background-color: #bcc4cc;
      border-radius: 4px;
    }

    &::after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
</style>
